var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"RegisteredBySubSeries",staticClass:"h-100",staticStyle:{"min-height":"500px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }